import { useGetArenaContestByIdQuery } from '@bo-services/arenaContestApi';

export const useArenaContest = ({ contestId }: { contestId: string }) => {
  const {
    data: response,
    isFetching,
    isError,
    isLoading,
    isSuccess
  } = useGetArenaContestByIdQuery(
    { contest_id: contestId },
    { skip: !contestId }
  );

  return {
    data: response,
    isFetching,
    isLoading,
    isSuccess,
    isError
  };
};
